import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#dce99b",
      main: "#bbd430",
      dark: "#8f9c14",
    },
    secondary: {
      light: "#ffffff",
      main: "#efefef",
      dark: "#000000",
    },
  },
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 18,
    htmlFontSize: 18,
    body1: {
      fontSize: "1.125rem",
    },
  },
});

export default theme;
